<template>
    <div class="container-fluid">
        <div class="row">
            <card>
                <div>
                    <h4 class="text-muted">Actions</h4>
                    <div class="btn-group ">
                        <base-button type="info" @click="$router.push('/systemrecording')">Your Recordings
                        </base-button>
                        <base-button type="default" @click="showCreateModal = true"
                                     class="right">
                            <font-awesome-icon :icon="['fal','plus']"></font-awesome-icon>
                            IVR
                        </base-button>

                    </div>
                </div>

            </card>
        </div>

        <IVRGrid></IVRGrid>
        <new-i-v-r-modal v-on:update-show="updateShow" v-on:created="loadIVRS"
                         :show.sync="showCreateModal"></new-i-v-r-modal>
    </div>
</template>

<script>

    import IVRGrid from "./IVRGrid";
    import NewIVRModal from "./NewIVRModal";

    export default {
        components: {NewIVRModal, IVRGrid},
        data() {
            return {
                showCreateModal: false,
            };
        },
        computed: {
            enableRTL() {
                return this.$route.query.enableRTL;
            },
            isRTL() {
                return this.$rtl.isRTL;
            },

        },
        methods: {
            updateShow(value) {
                this.showCreateModal = value;
            },
            loadIVRS() {
                this.isLoading = true;
                this.$store.dispatch('ivr/load').then(() => {
                    this.localIVRs = this.ivrs;
                    this.dirty = [];
                    this.names = [];
                    this.saving = [];
                    this.localIVRs.forEach(g => {
                        this.dirty.push(false);
                        this.names.push(g.name);
                        this.saving.push(false);
                    });
                    this.isLoading = false;
                })
            },
        },
        mounted() {
            this.i18n = this.$i18n;
            if (this.enableRTL) {
                this.i18n.locale = 'ar';
                this.$rtl.enableRTL();
            }
        },
        beforeDestroy() {
            if (this.$rtl.isRTL) {
                this.i18n.locale = 'en';
                this.$rtl.disableRTL();
            }
        }
    };
</script>
<style></style>
